
import { createRouter, createWebHistory } from 'vue-router';

export default createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '',
            component: () => import("@/Index.vue"),
            children: [
                {
                    path: '',
                    component: () => import("@/MyLRC.vue"),
                    children: [
                        {
                            path: '',
                            component: () => import("@/Login.vue"),
                            meta: {title: "My LRC - Login"}
                        },
                        {
                            path: '/Unsubscribe.html',
                            params: true,
                            component: () => import("@/Unsubscribe/Unsubscribe.vue"),
                            meta: { title: "My LRC - Unsubscribe" }
                        },
                        {
                            path: '/forgotUsernamePassword.html',
                            params: true,
                            component: () => import("@/ForgetPassword/ForgetPassword.vue"),
                             meta: { title: "My LRC - Forget Password" }
                        },
                        {
                            path: '/Legislature/:AppKey',
                            props: true,
                            component: () => import("@/Legislature/App.vue"),
                            meta: { title: "My LRC - Legislator Application" }
                        },
                        {
                            path: '/Verify.html',
                            params: true,
                            component: () => import("@/Verify/Verify.vue"),
                             meta: { title: "My LRC - Verify" }
                        },
                        {
                            path: '/PublicAPI',
                            redirect: '/PublicAPI.html',
                            
                        },
                        {
                            path: '/PublicAPI.html',
                            params: true,
                            component: () => import("@/PublicAPI/PublicAPI.vue"),
                            meta: { title: "My LRC - Public API" }
                        },
                        {
                            path: '/DraftLegislation.html',
                            params: true,
                            component: () => import("@/DraftLegislation/DraftLegislation.vue"),
                            meta: { title: "My LRC - Draft Legislation" }
                        },
                        {
                            path: '/SDPB/Audio.html',
                            params: true,
                            component: () => import("@/SDPB/Audio.vue"),
                            meta: { title: "My LRC - SDPB Audio" }
                        },
                        {
                            path: '/ConferenceCommittees/ConferenceCommittees.html',
                            params: true,
                            component: () => import("@/ConferenceCommittees/ConferenceCommittees.vue"),
                            meta: { title: "My LRC - Conference Committees" }
                        },
                    ]

                },
                {

                    path: '/Main',
                    component: () => import("@/App.vue"),
                    children: [

                        {
                            path: 'Dashboard',
                            redirect: '/main/Requests'
                        },
                        {
                            path: 'Calendar/:BillListId?',
                            props: true,
                            component: () => import("@/Committee/Calendar.vue"),
                            meta: { title: "My LRC - Meetings" }
                        },
                        {
                            path: 'LettersOfIntentReports',
                            component: () => import("@/AgencyStuff/LettersOfIntentReports.vue"),
                            meta: { title: "My LRC - Letters of Intent Reports" }
                        },
                        {
                            path: "Resources",
                            name: "Resources",
                            component: () => import("@/Resources/Resources.vue"),
                            meta: { title: "My LRC - Resources" }
                        },
                        {
                            path: "Documents",
                            name: "Documents",
                            props: { ShowPublicDocuments: true, ShowFavoriteDocuments: true, ShowRecentDocuments: true, ShowCommitteeDocuments: true },
                            component: () => import("@/Documents/TabDocuments.vue"),
                            meta: { title: "My LRC - Documents" }
                        },
                        {
                            path: 'Requests',
                            props: true,
                            component: () => import("@/Requests/Requests.vue"),
                            meta: { title: "My LRC - Requests" }
                        },
                        {
                            path: 'Document/:DocumentId?/:Guid?',
                            props: true,
                            component: () => import("@/Requests/Requests.vue"),
                            meta: { title: "My LRC - Document" }
                        },
                        {
                            path: 'LegislatorUpdate',
                            component: () => import("@/Resources/LegislatorUpdate.vue"),
                            meta: { title: "My LRC - Legislator Update" }
                        },
                        {
                            path: 'Notes',
                            component: () => import("@/Notes/Notes.vue"),
                            meta: { title: "My LRC - Notes" }
                        },
                        {
                            path: 'Rules',
                            component: () => import("@/Rules/Rules.vue"),
                            meta: { title: "My LRC - Rules" }
                        },
                        {
                            path: "BillLists",
                            name: "BillLists",
                            component: () => import("@/BillLists/BillLists.vue"),
                            meta: { title: "My LRC - Bills" }
                        },
                        {
                            path: "BillList",
                            name: "BillList",
                            component: () => import("@/BillLists/BillList.vue"),
                        },
                        {
                            path: "AddBill",
                            name: "AddBill",
                            component: () => import("@/BillLists/AddBill.vue"),
                        },
                        {
                            path: "AddCriteria",
                            name: "AddCriteria",
                            component: () => import("@/BillLists/AddCriteria.vue"),
                        },
                        {
                            path: 'Statutes',
                            component: () => import("@/Statutes/Statutes.vue"),
                            meta: { title: "My LRC - Statutes" }

                        },
                        {
                            path: 'SessionCommittees',
                            name: "SessionCommittees",
                            component: () => import("@/SessionCommittees/SessionCommittees.vue"),
                            meta: { title: "My LRC - Session Committees" }
                        },
                        {
                            path: 'InterimCommittees',
                            name: 'InterimCommittees',
                            component: () => import("@/InterimCommittees/InterimCommittees.vue"),
                            meta: { title: "My LRC - Interim Committees" }
                        },
                        {
                            path: 'ArchivedSessions',
                            component: () => import("@/ArchivedSessions/ArchivedSessions.vue"),
                            name: 'ArchivedSessions',
                            meta: { title: "My LRC - Archived Sessions" }

                        },
                        {
                            path: 'ArchivedSessions/ArchivedRequests',
                            props: true,
                            component: () => import("@/ArchivedSessions/ArchivedRequests.vue"),
                            meta: { title: "My LRC - Archived Requests" }
                        },
                        {
                            path: 'Notifications',
                            component: () => import("@/Notifications/Notifications.vue"),
                            name: 'Notifications',
                            meta: { title: "My LRC - Notifications" }
                        },
                        {
                            path: 'Tasks',
                            component: () => import("@/Tasks/Tasks.vue"),
                            name: 'Tasks',
                            meta: { title: "My LRC - Tasks" }
                        },
                        {
                            path: 'Tasks/AuthenticationError',
                            component: () => import("@/Tasks/AuthenticationError.vue"),
                        },
                        {
                            path: 'Committee/BillLogs',
                            name: 'BillLogs',
                            component: () => import("@/Committee/BillLogs.vue"),
                            meta: { title: "My LRC - Bill Logs" }
                        },
                        {
                            path: 'Sponsorship',
                            name: 'Sponsorship',
                            component: () => import("@/Sponsorship/Sponsorship.vue"),
                            meta: { title: "My LRC - Sponsorship" }
                        },
                        {
                            path: 'Survey/Intern',
                            component: () => import("@/Survey/Intern.vue"),
                            meta: { title: "My LRC - Intern Survey" }
                        },
                        {
                            path: 'Survey/Legislator',
                            component: () => import("@/Survey/Legislator.vue"),
                            meta: { title: "My LRC - Legislator Survey" }
                        },
                        {
                            path: 'Survey/LRC',
                            component: () => import("@/Survey/LRC.vue"),
                            meta: { title: "My LRC - LRC Survey" }
                        },
                        {
                            path: 'Survey/Surveys',
                            component: () => import("@/Survey/Surveys.vue"),
                            meta: { title: "My LRC - Surveys" }
                        },
                        {
                            path: 'Survey/General/:surveyId?',
                            props: true,
                            component: () => import("@/Survey/General.vue"),
                            meta: { title: "My LRC - General Survey" }
                        },
                        {
                            path: 'TravelRequest',
                            component: () => import("@/TravelRequest/TravelRequest.vue"),
                            meta: { title: "My LRC - Travel Request" }
                        },
                        //{
                        //    path: 'TravelRequest/SessionTravel/:SessionTravelId?',
                        //    props: true,
                        //    component: () => import("@/TravelRequest/SessionTravel.vue"),
                        //},
                        {
                            path: 'Assignments/Index',
                            component: () => import("@/Assignments/Index.vue"),
                            meta: { title: "My LRC - Assignments" }
                        },
                        {
                            path: 'Assignments/Bills',
                            component: () => import("@/Assignments/Bills.vue"),
                            meta: { title: "My LRC - Bills Assignments" }
                        },
                        {
                            path: 'Assignments/Members',
                            component: () => import("@/Assignments/MemberAssignment.vue"),
                            meta: { title: "My LRC - Member Assignments" }
                        },
                        {
                            path: 'InterimStudies',
                            redirect: () => '/InterimStudies/InterimStudies',
                        },
                        {
                            path: 'InterimStudies/InterimStudies',
                            component: () => import("@/InterimStudies/InterimStudies.vue"),
                            meta: { title: "My LRC - Interim Studies" }
                        },
                        {
                            path: 'InterimStudies/Rank',
                            component: () => import("@/InterimStudies/Rank.vue"),
                            meta: { title: "My LRC - Interim Studies Rank" }
                        },
                        {
                            path: 'InterimStudies/Serve',
                            component: () => import("@/InterimStudies/Serve.vue"),
                            meta: { title: "My LRC - Interim Studies Serve" }
                        },
                        {
                            path: 'Scenarios/:fiscalYear',
                            component: () => import("@/Legislator/Scenarios.vue"),
                            name: 'Scenarios',
                            props: true,
                            meta: { title: "My LRC - Scenarios" }
                        },
                        {
                            path: 'ScenariosViewer/:selectedYear/:selectedAgency',
                            component: () => import("@/Legislator/ScenariosViewer.vue"),
                            name: 'ScenariosViewer',
                            props: true,
                            meta: { title: "My LRC - Scenarios Viewer" }
                        },
                        {
                            path: 'Settings',
                            component: () => import("@/Settings/Settings.vue"),
                            meta: { title: "My LRC - Settings" }
                        },
                        {
                            path: 'LegislatorApp',
                            component: () => import("@/Legislator/LegislatorApp.vue"),
                            meta: { title: "My LRC - Legislator Application" }
                        },
                        {
                            path: 'Dashboard',
                            redirect: '/Requests'
                        },
                        {
                            path: 'Students/Intern/View',
                            component: () => import("@/Students/View.vue"),
                            meta: { title: "My LRC - Interns" }
                        },
                        {
                            name: 'InternApplication',
                            path: 'Students/Intern/Application/:InternId?',
                            props: (x) => {
                                return {
                                    Title: 'Intern Application',
                                    InternId: x.params.InternId
                                };
                            },
                            component: () => import("@/Students/Application.vue"),
                            meta: { title: "My LRC - Intern Application" }
                        },
                        {
                            name: 'PageApplication',
                            path: 'Students/Page/Application/:PersonId?',
                            props: {
                                Title: 'Page Application',
                            },
                            component: () => import("@/Students/Application.vue"),
                            meta: { title: "My LRC - Page Application" }
                        },
                        {
                            path: '/RegisteredTestifiers/:DocumentId?',
                            props: true,
                            component: () => import('@/Committee/TestifierPending.vue'),
                            meta: { title: "My LRC - Registered Testifiers" }
                        },
                        {
                            path: 'CommitteeLive',
                            component: () => import("@/CommitteeLive/CommitteeLive.vue"),
                            meta: { title: "My LRC - Committee Live" }
                        },
                        {
                            path: 'Live/:DocumentId',
                            props: true,
                            component: () => import('@/CommitteeLive/Live.vue'),
                            meta: { title: "My LRC - Committee Live" }
                        },
                        {
                            path: 'Housing',
                            props: true,
                            component: () => import('@/Housing/Housing.vue'),
                            meta: { title: "My LRC - Available Housing" }
                        },
                    ]
                }                
            ]
        },
        {
            path: '/',
            redirect: ''
        },

       
    ]
})